import { useDeferredThirdParty } from "@hooks/useDeferredThirdParty";
import Script from "next/script";
import { Fragment } from "react";

const Yandex = () => {
  const isInternationalScriptsDisabled =
    process.env.NEXT_PUBLIC_IS_INTERNATIONAL_SCRIPTS_ACTIVE === "false";
  const shouldLoad = useDeferredThirdParty(
    4500,
    !isInternationalScriptsDisabled
  );

  if (isInternationalScriptsDisabled || !shouldLoad) return null;

  return (
    <Fragment>
      <Script
        id="yandex-metrika-script"
        strategy="lazyOnload"
        dangerouslySetInnerHTML={{
          __html: `(function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
              m[i].l=1*new Date();
              for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}
              k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})
              (window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");
              ym(99491264, "init", {
                    clickmap:true,
                    trackLinks:true,
                    accurateTrackBounce:true
              });`,
        }}
      />
      <noscript>
        <div>
          <img
            src="https://mc.yandex.ru/watch/99491264"
            style={{ position: "absolute", left: "-9999px" }}
            alt=""
          />
        </div>
      </noscript>
    </Fragment>
  );
};

export default Yandex;
